import { useState } from 'react';
import PropTypes from 'prop-types';

import AppDialog from '#/modules/commonComponents/dialog/AppDialog';
import { Textarea } from '#/modules/commonComponents/form/Textarea';

/** 已發出／過期報價：單列（主或子項目）內部備註。開啟時以 key 重建。 */
const QuotationInternalRemarkDialog = ({ open, onOpenChange, target, isPending = false, onConfirm }) => {
  const [remark, setRemark] = useState(target?.internalRemark ?? '');

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="編輯內部備註"
      description={target?.label}
      onCancel={() => onOpenChange(false)}
      onConfirm={() => onConfirm(remark)}
      confirmText={isPending ? '儲存中…' : '儲存'}
      cancelText="取消"
      confirmDisabled={isPending}
    >
      <Textarea
        id="quotationInternalRemark"
        rows={4}
        aria-label="內部備註"
        value={remark}
        onChange={(event) => setRemark(event.target.value)}
      />
      <p className="text-xs text-muted-foreground">內部備註不輸出 Excel；清空即移除。</p>
    </AppDialog>
  );
};

QuotationInternalRemarkDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  target: PropTypes.object,
  isPending: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};

export default QuotationInternalRemarkDialog;
